import { Injectable } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Router } from '@angular/router';
import { BackendHealthService } from '@examdojo/error-handling';
import { ExamdojoSupabaseService } from '@examdojo/supabase';
import { ModalController } from '@ionic/angular/standalone';
import { merge, tap, throttleTime } from 'rxjs';

@Injectable()
export class RedirectOnFatalError {
  constructor(
    private readonly router: Router,
    private readonly supabaseService: ExamdojoSupabaseService,
    private readonly modalController: ModalController,
    private readonly backendHealthService: BackendHealthService,
  ) {
    merge(this.supabaseService.fatalErrorResponse$, this.backendHealthService.unhealthyBackend$)
      .pipe(
        throttleTime(2000),
        tap(() => {
          this.modalController.dismiss();
          this.router.navigate(['/error']);
        }),
        takeUntilDestroyed(),
      )
      .subscribe();
  }
}
